document.addEventListener('DOMContentLoaded', () => {
    const productList = document.querySelector('.product-loop__item').parentElement;
    console.log('productList',productList);
    const loadingSpinner = document.getElementById('LoadingSpinner');
    const paginationInfo = document.getElementById('PaginationInfo');
  
    let isLoading = false;
  
    const loadMoreProducts = async () => { 
      if (isLoading) return;
  
      const nextPage = paginationInfo.getAttribute('data-next-page');
      if (!nextPage) return; 
  
      isLoading = true;
      loadingSpinner.style.display = 'block';
  
      try {
        const response = await fetch(nextPage);
        if (!response.ok) throw new Error('Error');
        const html = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const newProducts = tempDiv.querySelectorAll('.product-loop__item');
        const newNextPage = tempDiv.querySelector('#PaginationInfo')?.getAttribute('data-next-page');
   
        newProducts.forEach(product => productList.appendChild(product));
        paginationInfo.setAttribute('data-next-page', newNextPage || '');
      } catch (error) {
        console.error(error);
      } finally {
        isLoading = false;
        loadingSpinner.style.display = 'none';
      }
    };

    window.addEventListener('scroll', () => {
      const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        loadMoreProducts();
      }
    });
  });
  